module.exports = __webpack_public_path__ + "img/add-appointment.80bf6134.svg";